import { motion, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

/**
 * Strava "Powered by" badge — 1s delay then 1s fade-in (respects reduced motion).
 */
export default function StravaPoweredByBadge({ className, imgClassName }) {
  const { t } = useLanguage();
  const reduceMotion = useReducedMotion();

  return (
    <motion.a
      href='https://www.strava.com'
      target='_blank'
      rel='noopener noreferrer'
      className={cn(
        'inline-flex rounded-md outline-offset-4 focus-visible:ring-2 focus-visible:ring-white/40',
        className
      )}
      initial={reduceMotion ? false : { opacity: 0 }}
      animate={{ opacity: 0.9 }}
      whileHover={{ opacity: 1 }}
      whileFocus={{ opacity: 1 }}
      transition={{
        opacity: {
          duration: reduceMotion ? 0 : 1,
          delay: reduceMotion ? 0 : 1,
          ease: [0.22, 1, 0.36, 1],
        },
      }}
    >
      <img
        src='/brand/logos/Powered-by-strava-white-txt.png'
        alt={t('strava.poweredByBadgeAlt')}
        className={cn(
          'h-7 w-auto max-w-[min(100vw-2rem,11rem)] object-contain object-right sm:h-8',
          imgClassName
        )}
      />
    </motion.a>
  );
}
